export default __webpack_public_path__ + "static/media/PersonswithDisabilities_fr.bc5fbcdc.svg";